export enum ApiErrors {
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
}

export const getApiError = (errorCode: ApiErrors): ApiErrors | null => {
  if (!errorCode) return null;

  return Object.values(ApiErrors).includes(errorCode) ? errorCode : null;
};
